/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Artifacts_Tray_LabelInputs */



/**
* | output |
* | --- |
* | "Artifacts" |
*
* @param {Chat_Artifacts_Tray_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_artifacts_tray_label = /** @type {((inputs?: Chat_Artifacts_Tray_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Artifacts_Tray_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Artefakte")
	return /** @type {LocalizedString} */ ("Artifacts")
});